// extracted by mini-css-extract-plugin
export default {"card":"style_card__7KrTx","fix":"style_fix__qWSLi","content":"style_content__wxvsw","item":"style_item__MMK9-","eye":"style_eye__bcm15"};